import { useEffect, useRef } from 'react';

/**
 * Always know when a component is mounted and can participate in data flow (ie. state, props).
 * Useful when exceptions are logged that state cannot be set on an unmounted component.
 */
export const useMounted = () => {
  const mounted = useRef(true);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
  return mounted;
};
